import * as React from "react";

function SvgIconMaterialChatBubbleOutline(props) {
  return (
    <svg width={24} height={24} {...props}>
      <path
        data-name="Icon material-chat_bubble_outline"
        d="M21.6 0H2.4A2.407 2.407 0 000 2.4V24l4.8-4.8h16.8a2.407 2.407 0 002.4-2.4V2.4A2.407 2.407 0 0021.6 0zm0 16.8H4.8l-2.4 2.4V2.4h19.2z"
        fill="#333"
      />
    </svg>
  );
}

export default SvgIconMaterialChatBubbleOutline;
